import { call, put, takeLatest, Effect } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    getAppLogs,
    getAppLogsSuccess,
    getAppLogsFailure,
    getMoreAppLogs,
    getMoreAppLogsSuccess,
    downloadAppLog,
    downloadAppLogSuccess,
    downloadAppLogFailure,
} from "@/store/slices/appLogs.slice";
import { IAppLogResponse, IFetchAppLogs } from "@/pages/SmartCoolers/smartCooler.interface";
import { fetchAppLogs, downloadAppLogReport } from "@/services/appLogs";

function* fetchAppLogsSaga(
    action: PayloadAction<IFetchAppLogs>
): Generator<Effect, void, any> {
    try {
        const response: AxiosResponse<IAppLogResponse> = yield call(
            fetchAppLogs,
            action.payload
        );
        if (response?.data) {
            yield put(getAppLogsSuccess(response.data));
        } else {
            yield put(getAppLogsFailure({ message: "No data received" }));
        }
    } catch (error: any) {
        const errorData = error?.response?.data || {
            message: error.message || "Unknown Error",
        };
        yield put(getAppLogsFailure(errorData));
    }
}

function* handleDownloadAppLog(action: any) {
    try {
        yield call(downloadAppLogReport, action.payload.logId);
        yield put(downloadAppLogSuccess());
    } catch (error: any) {
        const message = error?.response?.data?.message || error?.message || "Download failed.";
        yield put(downloadAppLogFailure(message) as any);
    }
}

function* fetchMoreAppLogsSaga(
    action: PayloadAction<IFetchAppLogs>
): Generator<Effect, void, any> {
    try {
        const response: AxiosResponse<IAppLogResponse> = yield call(
            fetchAppLogs,
            action.payload
        );
        if (response?.data) {
            yield put(getMoreAppLogsSuccess(response.data));
        } else {
            yield put(getAppLogsFailure({ message: "No data received" }));
        }
    } catch (error: any) {
        const errorData = error?.response?.data || {
            message: error.message || "Unknown Error",
        };
        yield put(getAppLogsFailure(errorData));
    }
}

function* appLogSaga() {
    yield takeLatest(getAppLogs.type, fetchAppLogsSaga);
    yield takeLatest(getMoreAppLogs.type, fetchMoreAppLogsSaga);
    yield takeLatest(downloadAppLog.type, handleDownloadAppLog);
}

export default appLogSaga;
